import type {
  LLMIntegrationsResponse,
  LLMIntegrationUpsertInput,
  LLMIntegrationUpsertResponse,
  LLMProvider,
  TwilioIntegration,
  TwilioIntegrationUpsertInput,
} from "@chat-yai/shared/admin-types";
import { request } from "@/api/client";

export const integrationsApi = {
  listLlm() {
    return request<LLMIntegrationsResponse>("/admin/integrations/llm");
  },
  upsertLlm(input: LLMIntegrationUpsertInput) {
    return request<LLMIntegrationUpsertResponse>("/admin/integrations/llm", {
      method: "PUT",
      body: input,
    });
  },
  removeLlm(provider: LLMProvider) {
    return request<{ ok: true }>(`/admin/integrations/llm/${provider}`, {
      method: "DELETE",
    });
  },
  // ---- WP-F Twilio --------------------------------------------------------
  getTwilio() {
    return request<TwilioIntegration>("/admin/integrations/twilio");
  },
  putTwilio(input: TwilioIntegrationUpsertInput) {
    return request<TwilioIntegration>("/admin/integrations/twilio", {
      method: "PUT",
      body: input,
    });
  },
  deleteTwilio() {
    return request<{ ok: true }>("/admin/integrations/twilio", {
      method: "DELETE",
    });
  },
};
